'use client'

import { RiskLeaderboard } from '@/components/RiskLeaderboard'
import { Button } from '@/components/ui/button'
import { Avatar, AvatarFallback } from '@/components/ui/avatar'
import { ChevronLeft, User } from 'lucide-react'
import Link from 'next/link'

export default function LeaderboardPage() {
  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="border-b bg-card">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <Link href="/">
                <Button variant="ghost" size="sm">
                  <ChevronLeft className="h-4 w-4 mr-2" />
                  대시보드로 돌아가기
                </Button>
              </Link>
              <div className="flex items-center gap-3">
                <img src="/soma/logo.png" alt="SOMA" className="h-10" />
                <h1 className="text-xl font-bold">위험도 리더보드</h1>
              </div>
            </div>
            <Avatar>
              <AvatarFallback>
                <User className="h-5 w-5" />
              </AvatarFallback>
            </Avatar>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="container mx-auto px-4 py-6">
        <RiskLeaderboard wardId="3A" autoRefresh={true} refreshInterval={10000} />
      </main>
    </div>
  )
}